/**
 * Subscription category.
 * @type {{ PRIMARY: string; AUXILIARY: string; MAX: string }}
 */
export const SUBSCRIPTION_CATEGORY = {
	PRIMARY: 'primary',
	AUXILIARY: 'auxiliary',
	MAX: 'max',
};

/**
 * Subscription type.
 * @type {{ MONTHLY: string; ANNUAL: string; SEMIANNUAL: string }}
 */
export const SUBSCRIPTION_TYPE = {
	MONTHLY: 'monthly',
	ANNUAL: 'annual',
	SEMIANNUAL: 'semiannual',
};
